import { inject, Injector } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { ApplicationLogic } from './logic/application.logic';
import { PrivilegeService } from './service/privilege.service';

export const appTypeGuard: CanActivateFn = (route, state): boolean => {
  const appType = route.data['appType'];
  if (typeof appType !== 'number') {
    return true;
  }

  const privilegeSrv = inject(PrivilegeService);
  const applicationLogic = ApplicationLogic.getInstance(inject(Injector));
  if (state.url.indexOf('/passport/login') >= 0) {
    if (privilegeSrv.appType && privilegeSrv.appType !== appType) {
      applicationLogic.toLogin(null, null, appType, null, false);
    }
    return true;
  }

  if (!privilegeSrv.appType || privilegeSrv.appType === appType) {
    return true;
  }

  applicationLogic.toLogin(null, null, appType, null, false);
  return false;
};
